import { useContext, useEffect, useLayoutEffect } from 'react';
import { LayoutConfig, LayoutConfigContext } from '@/context/layoutConfig/layoutConfigProivder';

export default function useLayoutConfig(config?: LayoutConfig) {
    const { hasNavbar, hasHobe, setLayoutConfig } = useContext(LayoutConfigContext);

    useLayoutEffect(() => {
        if (config) {
            setLayoutConfig(config);
        }
    }, []);

    return {
        hasNavbar,
        hasHobe
    };
}